import React from "react";
import "../../styles/RecentActivity.css";

const RecentActivity = ({ data = [] }) => {
  return (
    <div className="recent-activity">
      <h3>Atividades Recentes</h3>
      <table>
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Descrição</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td>{item.tipo}</td>
              <td>{item.descricao}</td>
              <td>{item.data}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecentActivity;
